import React from 'react';
import { Check } from 'lucide-react';

const WhatsIncluded = () => {
  const items = [
    'Governance Health Assessment',
    'Governance Maturity Framework',
    'Governance Scoring System',
    'Board Effectiveness Assessment',
    'Governance Gap Analysis',
    'Risk & Oversight Frameworks',
    'Governance Improvement Roadmap',
    '90-Day Action Planning',
    'Governance Reporting Templates',
    'Progress Tracking Tools',
    'Multi-User Collaboration',
    'Lifetime Access',
  ];

  return (
    <section id="whats-included" className="py-24 md:py-32 px-6 border-t border-ink/5 bg-white/40 backdrop-blur-sm relative">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-ink mb-6">
            Everything you need
          </h2>
          <p className="text-xl md:text-2xl font-semibold text-ink mb-6">
            To run a governance review <span className="text-lime bg-ink px-3 py-1 rounded-lg inline-block ml-1 shadow-sm">in-house.</span>
          </p>
          <p className="text-lg md:text-xl text-ink/60 max-w-3xl mx-auto leading-relaxed font-medium">
            GovernWell combines the tools, frameworks, assessments, and reporting typically
            delivered through external governance consultancy engagements.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 max-w-5xl mx-auto">
          {items.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 bg-white border border-ink/5 rounded-2xl p-5 shadow-saas-sm hover:border-ink/10 hover:shadow-md transition-all"
            >
              <div className="w-8 h-8 rounded-full bg-lime/20 flex items-center justify-center shrink-0">
                <Check className="w-4 h-4 text-ink" strokeWidth={3} />
              </div>
              <span className="font-semibold text-ink/80">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatsIncluded;
